export default __webpack_public_path__ + "static/media/LebenswerkConsulting.11b50708.svg";